var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":("Contract Details: " + (_vm.invoices[0].contract_number))}},[_c('contract-detail-listings',{attrs:{"invoices":_vm.invoices}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }